<template>

  <v-container fluid v-if="invoices">

    <im-page-title
      title="Listă Facturi"
    />

    <im-invoices-tool
      :query.sync="query"
      @create="goToCreate"
    />

    <div class="ma-3">
      <v-progress-linear
        :indeterminate="querying"
        :color="querying ? 'primary' : 'grey'"
        rounded
      />
    </div>

    <im-invoices-list
      :invoices="invoices"
      :pagination.sync="pagination"
      @edit="goToEdit"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import _ from "lodash";
  import invoice_repository from '@/repositories/invoice-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-invoices-tool': () => import('@/components/Invoice/InvoiceToolbar'),
      'im-invoices-list': () => import('@/components/Invoice/InvoiceList')
    },

    data: () => ({
      invoices: null,
      query: null,
      querying: false,
      pagination: {size: 10, page: 1}
    }),

    watch: {
      query: {
        handler: 'fetchInvoicesDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchInvoices',
        immediate: false
      }
    },

    methods: {

      fetchInvoicesDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchInvoices()
      }, 300),

      async fetchInvoices() {
        try {
          this.querying = true;
          this.invoices = await invoice_repository.getInvoices(this.query, this.pagination, {});
        } catch (e) {
          await this.$store.dispatch('alert/error', e)
        } finally {
          this.querying = false;
        }
      },

      goToCreate() {
        this.$router.push(`/invoices/create`);
      },

      goToEdit(invoice) {
        this.$router.push(`/invoices/${invoice.id}`);
      }

    }

  }

</script>